import { render, staticRenderFns } from "./EmbeddedChatBody.vue?vue&type=template&id=ddb28134&"
import script from "./EmbeddedChatBody.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedChatBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports